import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import HeadColumn from '@/components/common/HeadColumn.vue'
import {namespace} from 'vuex-class'

const uiModule = namespace('ui')

@Component({
  components: {
    HeadColumn
  }
})
export default class BaseList extends Vue {
  @Prop(String) title!: string
  @Prop(String) subtitle!: string
  @Prop(Array) data!: object[]
  @Prop(Array) rows!: object[]
  @Prop(Object) sortParams!: object
  @Prop(Object) paginationParams!: any
  @Prop(Boolean) hasActions!: boolean
  @Prop(Boolean) isSelectable!: boolean
  @uiModule.Getter('isLoadingGetter') isLoading: boolean

  get limit() {
    return this.paginationParams ? this.paginationParams.perPage : 0
  }

  set limit(value) {
    this.$emit('changeLimit', value)
  }

  get total() {
    return this.paginationParams ? this.paginationParams.total : 0
  }

  get lastPage() {
    return this.paginationParams ? Number(this.paginationParams.lastPage) : 0
  }

  get page() {
    return this.paginationParams ? Number(this.paginationParams.page) : 1
  }

  get isEmpty() {
    return this.data && this.data.length === 0
  }

  get limitComplexPagination() {
    return 10
  }

  get displayComplexPagination() {
    return 4
  }

  get isComplexPagination() {
    return this.lastPage > this.limitComplexPagination
  }

  getComplexPaginationItems(page) {
    const arr = []
    if (page < this.displayComplexPagination) {
      if (page === 1) {
        const p = page + 1
        for (let i = p; i < p + this.displayComplexPagination; i++) {
          arr.push(i)
        }
        return arr
      } else {
        const p = 2
        for (let i = p; i < p + this.displayComplexPagination; i++) {
          arr.push(i)
        }
        return arr
      }
    }
    if (page >= this.displayComplexPagination && page < this.lastPage - this.displayComplexPagination) {
      const p = page - this.displayComplexPagination / 2
      for (let i = p; i < p + this.displayComplexPagination + 1; i++) {
        arr.push(i)
      }
      return arr
    }
    if (page >= this.lastPage - this.displayComplexPagination && page < this.lastPage) {
      const p = this.lastPage - this.displayComplexPagination
      for (let i = p; i < p + this.displayComplexPagination; i++) {
        arr.push(i)
      }
      return arr
    }
    if (page === this.lastPage) {
      const p = this.lastPage - this.displayComplexPagination
      for (let i = p; i < p + this.displayComplexPagination; i++) {
        arr.push(i)
      }
      return arr
    }
  }

  onDetailHandler(id: any) {
    this.$emit('detail', id)
  }

  onSortHandler(data: any) {
    this.$emit('sort', data)
  }

  onPaginateHandler(page: any) {
    this.$emit('paginate', page)
  }

  onPaginatePrevHandler(page: any) {
    const nextPage = Number(page) - 1
    this.$emit('paginate:prev', String(nextPage))
  }

  onPaginateNextHandler(page: any) {
    const prevPage = Number(page) + 1
    this.$emit('paginate:next', String(prevPage))
  }
}
